import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {SnackbarData} from '../snackbar-data';
import {TranslatePipe} from '@ngx-translate/core';
import {MatIcon} from '@angular/material/icon';
import {Router} from '@angular/router';

@Component({
  selector: 'app-custom-snack-bar',
  imports: [
    TranslatePipe,
    MatIcon,
  ],
  templateUrl: './custom-snack-bar.component.html',
  styleUrl: './custom-snack-bar.component.scss'
})
export class CustomSnackBarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
              private router: Router,
              public snackRef: MatSnackBarRef<CustomSnackBarComponent>,) { }

  login() {
    this.router.navigate(['/login']).then();
    this.snackRef.dismiss();
  }

}
